module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.2abaabb.woff2";